var map = {
	"./BHAGYA GOLD-01.jpg": 1325,
	"./MANJALI LOGO-01.jpg": 9230,
	"./MEDIA ONE LOGO 01.jpg": 6281,
	"./Madhyamam-logo.jpg": 6938,
	"./Malayala-Manorama-logo.jpg": 9358,
	"./RED FM LOGO.jpg": 3178,
	"./RSP LOGO.jpg": 6823,
	"./SAMKARATHIL SILKS LOGO-01.jpg": 7543,
	"./SREENETHRA LOGO-01.jpg": 1765,
	"./SWAYAMVARA LOGO-01.jpg": 9086,
	"./allanscott.jpg": 9098,
	"./asianet logo.jpg": 3211,
	"./channels4_profile.jpg": 993,
	"./divya prabha logo.jpg": 7191,
	"./kairali logo-01.jpg": 9195,
	"./ramco.jpg": 2169
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 655;